import featuredAthletes from './featuredAthletes.png';
import heroCarousel from './heroCarousel.png';
import latestNews from './latestNews.png';
import latestNewsPanel from './latestNewsPanel.png';
import lifestyleGrid from './lifestyleGrid.png';
import lifestylePanel from './lifestylePanel.png';
import newsCarousel from './newsCarousel.png';
import newsletterSignup from './newsletterSignup.png';
import nextEvent from './nextEvent.png';
import pastEventResult from './pastEventResult.png';
import singlePageFeature from './singlePageFeature.png';
import socialMediaLinks from './socialMediaLinks.png';
import statsPanel from './statsPanel.png';
import textBlock from './textBlock.png';
import timeTable from './timeTable.png';
import usefulLinks from './usefulLinks.png';
import videCarousel from './videoCarousel.png';
import newsArticleRow from './newsArticleRow.png';
import promotionalBanner from './promotionalBanner.png';
import liveBlog from './liveBlog.png';
import LibraryPanel from './LibraryPanel.png';
import TabbedModule from './tabbedModule.png';

export default {
  featuredAthletes,
  heroCarousel,
  latestNews,
  latestNewsPanel,
  lifestyleGrid,
  lifestylePanel,
  newsCarousel,
  newsletterSignup,
  nextEvent,
  pastEventResult,
  singlePageFeature,
  socialMediaLinks,
  statsPanel,
  textBlock,
  timeTable,
  usefulLinks,
  videCarousel,
  newsArticleRow,
  emailPromotionalBanner: promotionalBanner,
  promotionalBanner: newsCarousel,
  singleNewsArticle: newsCarousel,
  liveBlog,
  LibraryPanel,
  TabbedModule,
};
